// Load YouTube iframe API
if (!window["YT"]) {
  var tag = document.createElement("script");
  tag.src = "https://www.youtube.com/iframe_api";
  var firstScriptTag = document.getElementsByTagName("script")[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

// Store all YouTube player instances
var players = {};

// This function will be called when YouTube API is ready
function onYouTubeIframeAPIReady() {
  var iframes = document.querySelectorAll(".video-autoplay-iframe");

  iframes.forEach(function (iframe) {
    if (iframe.src.includes("youtube.com") && iframe.id) {
      // Extract section ID from iframe ID (e.g., "ytPlayer-123" -> "123")
      var sectionId = iframe.id.replace("ytPlayer-", "");

      // Create player from existing iframe
      players[sectionId] = new YT.Player(iframe, {
        events: {
          onReady: function (event) {
            onPlayerReady(event, sectionId);
          },
        },
      });
    }
  });
}

// When player is ready, set up mute button
function onPlayerReady(event, sectionId) {
  var muteBtn = document.getElementById("toggleMuteBtn-" + sectionId);
  var currentPlayer = players[sectionId];

  if (muteBtn && currentPlayer) {
    muteBtn.addEventListener("click", function () {
      if (currentPlayer.isMuted()) {
        currentPlayer.unMute();
        muteBtn.textContent = "🔇 Mute Sound";
        muteBtn.classList.add("unmuted");
      } else {
        currentPlayer.mute();
        muteBtn.textContent = "🔊 Turn On Sound";
        muteBtn.classList.remove("unmuted");
      }
    });
  }
}

// If YouTube API is already loaded, initialize immediately
if (window["YT"] && window["YT"].Player) {
  onYouTubeIframeAPIReady();
}
